
import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core / Typography';

const styles = theme => ({
  container: {
    textAlign: 'left',
    borderLeft:'3px solid #165469',
    minHeight:'125px',
    maxHeight:'125px',
    [theme.breakpoints.up('tablet')]: {
      minHeight:'140px',
      maxHeight:'140px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight:'160px',
      maxHeight:'160px',
    },
  },
  filterTitle: {
    paddingLeft: '5px',
    paddingBottom:'20px',
  },
  filterOption: {
    paddingLeft: '30px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor:'#dbdbdb',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12pt',
    },
  },
  active: {
    paddingLeft: '25px',
    fontWeight: '700!important',
  },
});

function FilterSelector(props) {
  const { classes } = props;

  let totalProduction
  let totalPerInhabitant
  let totalPerSurface
  switch (props.lang) {
    case "de":
      totalProduction = 'Total'
      totalPerInhabitant = 'Per inhabitant'
      totalPerSurface = 'Per km\u00b2'
      break;
    case "en":
      totalProduction = 'Total'
      totalPerInhabitant = 'Per inhabitant'
      totalPerSurface = 'Per km\u00b2'
      break;
    case "fr":
      totalProduction = 'Totale'
      totalPerInhabitant = 'Par habitant'
      totalPerSurface = 'Par km\u00b2'
      break;
    case "nl":
    default:
      totalProduction = 'Productie per gemeente'
      totalPerInhabitant = 'Productie per inwoner'
      totalPerSurface = 'Productie per km\u00b2'
  }

  return (
    <div className={classes.container}>
      <div
        className={classes.filterTitle + '  darkbluegreen'}>Kies</div>
      <div
        className={classes.filterOption + ' ' + (props.currentFilter === 'energy' ? (classes.active + ' darkbluegreen') : 'darkgrey')}
        data-filter='energy'
        onClick={props.setFilter}
      >
        {totalProduction}
      </div>
      <div
        className={classes.filterOption + ' ' + (props.currentFilter === 'inhabitants' ? (classes.active + ' darkbluegreen') : 'darkgrey')}
        data-filter='inhabitants'
        onClick={props.setFilter}
      >
        {totalPerInhabitant}
      </div>
      <div
        className={classes.filterOption + ' ' + (props.currentFilter === 'surface' ? (classes.active + ' darkbluegreen') : 'darkgrey')}
        data-filter='surface'
        onClick={props.setFilter}
      >
        {totalPerSurface}
      </div>
    </div>
  );
}

FilterSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FilterSelector);
